var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "results-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("\n      " + _vm._s(_vm.motivational) + "\n      "), _c('span')])]), _c('div', {
    staticClass: "chart",
    style: {
      backgroundImage: 'url(' + _vm.spotCheckBg + '), none'
    }
  }, [_c('div', {
    staticClass: "spotCheckType"
  }, [_vm._v(_vm._s(_vm.spotCheckType))]), _c('div', {
    staticClass: "myBestTitle"
  }, [_vm._v("My Best")]), _c('div', {
    staticClass: "statsHolder"
  }, [_c('ul', {
    staticClass: "border"
  }, [_c('li', {
    staticClass: "category"
  }, [_vm._v("Time:")]), _c('li', {
    staticClass: "statsValue"
  }, [_c('div', [_vm._v("\n            " + _vm._s(_vm.result.min) + "\n            "), _c('span', {
    staticClass: "statsValueDecorator"
  }, [_vm._v("min")])]), _c('div', [_vm._v("\n            " + _vm._s(_vm.result.sec) + "\n            "), _c('span', {
    staticClass: "statsValueDecorator"
  }, [_vm._v("sec")])])])]), _c('ul', [_c('li', {
    staticClass: "category smaller"
  }, [_vm._v("\n          " + _vm._s(_vm.perMinuteLabel) + ":\n          "), _c('span', [_vm._v("(" + _vm._s(_vm.perMinuteLabelAbbreviation) + ")")])]), _c('li', {
    staticClass: "statsValue"
  }, [_vm._v(_vm._s(_vm.result.wpm))])]), _c('ul', {
    staticClass: "border more"
  }, [_c('li', {
    staticClass: "category"
  }, [_vm._v("Errors:")]), _c('li', {
    staticClass: "statsValue"
  }, [_vm._v(_vm._s(_vm.result.numErr))])]), _c('ul', [_c('li', {
    staticClass: "category"
  }, [_vm._v("Accuracy:")]), _c('li', {
    staticClass: "statsValue"
  }, [_vm._v(_vm._s(_vm.result.accuracy) + "%")])]), _c('div', {
    staticClass: "myBest"
  }, [_c('div', {
    staticClass: "ribbon",
    class: {
      show: _vm.result.isNewBest
    },
    style: {
      backgroundImage: 'url(' + _vm.ribbon + '), none'
    }
  }), _c('div', {
    staticClass: "newBest",
    class: {
      show: _vm.result.isNewBest
    }
  }, [_vm._v("NEW BEST!")]), _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.perMinuteLabel))]), _c('div', {
    staticClass: "bestWpm"
  }, [_vm._v(_vm._s(_vm.result.bestResultsWPM))]), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Accuracy")]), _c('div', {
    staticClass: "bestAccuracy"
  }, [_vm._v(_vm._s(_vm.result.bestResultsAccuracy) + "%")])])])]), _c('div', {
    staticClass: "spotCheckNext"
  }, [_vm.showRetryBtn ? _c('a', {
    staticClass: "spotCheckButton",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.redoSpotCheck($event);
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svgTryAgain)
    }
  }), _c('span', [_vm._v("Try Again")])]) : _vm._e(), _vm.kwtMode !== 'preview' ? _c('a', {
    staticClass: "spotCheckButton",
    staticStyle: {
      "margin-left": "210px"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.continueCurriculum($event);
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svgQuit)
    }
  }), _c('span', [_vm._v("Skip Ahead")])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }